var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"painel"},[_c('div',[_c('v-card-text',[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }